import React, { useEffect, useState } from 'react'
import { Window } from '@progress/kendo-react-dialogs'
import { Fade } from '@progress/kendo-react-animation'

import VIEW_DOCUMENT_IMAGE from '../../../public/assets/view_document_image.svg'
import CLOSE_DEFAULT from '../../../public/assets/window-close-default.svg'
import { PDFViewer } from '@progress/kendo-react-pdf-viewer'

const EmptyWindowAction = () => null

const PDF_VIEWER_TOOLS = [
  'pager',
  'spacer',
  'zoomInOut',
  'zoom',
  'spacer',
  'download',
  'print',
]

/**
 * PDFPreviewWindow
 * props:
 *  - visible: boolean 是否显示
 *  - onClose: function 关闭回调
 *  - title: string 标题
 *  - pdfUrl: string PDF 地址
 *  - width, height: 可选宽高
 */
export const PDFPreviewWindow = ({
  visible,
  onClose,
  title,
  pdfUrl,
  width,
  height,
  hideMinimizeButton = false,
  hideMaximizeButton = false,
  useCustomActions = false,
  onActionInteraction = () => {},
  className = '',
}) => {
  const [position, setPosition] = useState({ top: 100, left: 100 })

  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight

  const computedWidth = width
    ? width
    : Math.min(Math.max(screenWidth * 0.6, 300), 700)
  const computedHeight = height
    ? height
    : Math.min(Math.max(screenHeight * 0.6, 300), 700)

  useEffect(() => {
    if (visible) {
      const top = screenHeight / 2 - computedHeight / 2
      const left = screenWidth / 2 - computedWidth / 2
      setPosition({ top, left })
    }
  }, [visible, computedWidth, computedHeight, screenHeight, screenWidth])

  const TitleComponent = () => {
    return (
      <div
        className={
          useCustomActions ? 'custom-floating-window-title' : undefined
        }
        onClick={event => event.stopPropagation()}
        onMouseDown={event => {
          onActionInteraction?.()
          event.stopPropagation()
        }}
        onTouchStart={event => {
          onActionInteraction?.()
          event.stopPropagation()
        }}
        onWheelCapture={onActionInteraction}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          justifyContent: useCustomActions ? 'space-between' : undefined,
          width: useCustomActions ? '100%' : undefined,
          color: '#141414',
          fontWeight: 600,
          fontSize: 18,
        }}
      >
        <span style={{ alignItems: 'center', display: 'inline-flex', gap: 10 }}>
          <img src={VIEW_DOCUMENT_IMAGE} alt="icon" />
          <span>{title}</span>
        </span>
        {useCustomActions && (
          <span className="custom-floating-window-actions">
            <button
              className="custom-floating-window-action custom-floating-window-action--close"
              onClick={event => {
                onActionInteraction?.()
                event.preventDefault()
                event.stopPropagation()
                onClose()
              }}
              onMouseDown={event => {
                onActionInteraction?.()
                event.preventDefault()
                event.stopPropagation()
                onClose()
              }}
              onTouchStart={event => {
                onActionInteraction?.()
                event.preventDefault()
                event.stopPropagation()
                onClose()
              }}
              type="button"
              aria-label="Close window"
            >
              <img src={CLOSE_DEFAULT} alt="" />
            </button>
          </span>
        )}
      </div>
    )
  }
  return (
    <Fade
      in={visible}
      transitionEnterDuration={200}
      transitionExitDuration={150}
    >
      {visible && (
        <Window
          className={`custom-floating-window ${className}`.trim()}
          stage="FULLSCREEN"
          title={<TitleComponent />}
          top={position.top}
          left={position.left}
          initialWidth={computedWidth}
          initialHeight={computedHeight}
          draggable={true}
          resizable={true}
          onClose={useCustomActions ? undefined : onClose}
          minimizeButton={
            hideMinimizeButton || useCustomActions
              ? EmptyWindowAction
              : undefined
          }
          maximizeButton={
            hideMaximizeButton || useCustomActions
              ? EmptyWindowAction
              : undefined
          }
          restoreButton={
            hideMaximizeButton || useCustomActions
              ? EmptyWindowAction
              : undefined
          }
          closeButton={useCustomActions ? EmptyWindowAction : undefined}
          style={{ zIndex: 1000001, padding: 0 }}
        >
          <div
            className="custom-floating-window__body"
            onMouseDown={event => {
              onActionInteraction?.()
              event.stopPropagation()
            }}
            onTouchStart={event => {
              onActionInteraction?.()
              event.stopPropagation()
            }}
            onWheelCapture={onActionInteraction}
            style={{
              padding: 20,
              backgroundColor: '#fff',
              width: '100%',
              height: '100%',
              overflow: 'auto',
              boxSizing: 'border-box',
            }}
          >
            {pdfUrl ? (
              <PDFViewer
                url={pdfUrl}
                saveFileName={title}
                tools={PDF_VIEWER_TOOLS}
                style={{ height: '100%' }}
              />
            ) : (
              <div style={{ textAlign: 'center', paddingTop: 50 }}>
                No PDF available
              </div>
            )}
          </div>
        </Window>
      )}
    </Fade>
  )
}
